<div class="activate-page">
  <app-top-nav-registration></app-top-nav-registration>

  <form #activateForm="ngForm" class="activate-page__main">
    <div class="container activate-page__container">
      <div class="login-content activate-page__content" role="main">
        <div class="login-form activate-page__form">
          <h1 class="bb-login-heading activate-page__heading" aria-label="Activate account heading">
            <strong>Activate User Account</strong>
          </h1>

          <p class="activate-page__description">
            Create a password of at least 12 characters with uppercase, lowercase, and a number to activate your account.
          </p>

          <input type="hidden" [(ngModel)]="activationDetailsUser.activationGuid" name="activationGuid" />

          <mat-form-field appearance="outline" floatLabel="always" aria-label="Email Id" class="activate-page__field">
            <mat-label>Email</mat-label>
            <input matInput [(ngModel)]="userEmail" class="form-control-textbox" name="email" disabled="true" />
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always" aria-label="Password" class="activate-page__field">
            <mat-label>Update your password</mat-label>
            <input
              matInput
              type="password"
              [(ngModel)]="activationDetailsUser.password"
              name="newPassword"
              class="form-control-textbox"
              required
              pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{12,}"
              #newpassword="ngModel" />
            @if (newpassword.invalid && newpassword.touched) {
              <mat-error>
                Password must be at least 12 characters, including at least one uppercase letter, one lowercase letter, and one number
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always" aria-label="Confirm Password" class="activate-page__field">
            <mat-label>Confirm</mat-label>
            <input
              matInput
              type="password"
              class="form-control-textbox"
              [(ngModel)]="confirmPassword"
              name="confirmPassword"
              required
              #confirmpassword="ngModel" />
            @if (confirmpassword.invalid && confirmpassword.touched) {
              <mat-error>Field is required</mat-error>
            }
          </mat-form-field>

          @if (activationDetailsUser.password && confirmPassword && activationDetailsUser.password != confirmPassword) {
            <div class="activate-page__mismatch">
              <span class="confirm-password-error">Passwords do not match.</span>
            </div>
          }

          <div class="form-buttons activate-page__submit">
            <input
              type="submit"
              (click)="activateRA(activateForm)"
              class="bb-login-button"
              value="Submit"
              aria-label="Submit" />
          </div>
        </div>
      </div>
    </div>
  </form>

  <app-footer [bbapp]="true" [showLogos]="true"></app-footer>
</div>
